import React from 'react';
import { TRANSPORT_TYPE } from '@monorepo/dictionary';
import { SelectField, TFormField } from '@monorepo/forms';
import { enumToSelectOptions } from '@monorepo/helpers';
import { prepareOptions } from '@monorepo/ui-kit';
import { useI18n } from '@monorepo/i18n';

const TransportTypeSelect = <
  TFormValues extends Record<string, any> = Record<string, any>
>(
  props: TFormField<TFormValues>
) => {
  const { t } = useI18n();

  // Choose correct constants based on flag
  const conditionEnum = TRANSPORT_TYPE;
  const translationPrefix = 'transporttype.';

  return (
    <SelectField<TFormValues>
      options={prepareOptions(
        enumToSelectOptions(conditionEnum),
        t,
        translationPrefix
      )}
      {...props}
    />
  );
};

export default TransportTypeSelect;
